var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRefreshChart = function SvgRefreshChart(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F9EEDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 10H11.8333C10.8204 10 10 10.8204 10 11.8333V24.6667C10 25.6796 10.8204 26.5 11.8333 26.5H24.6667C25.6796 26.5 26.5 25.6796 26.5 24.6667V11.8333C26.5 10.8204 25.6796 10 24.6667 10ZM15.5 22.8333H13.6667V16.4167H15.5V22.8333ZM19.1667 22.8333H17.3333V13.6667H19.1667V22.8333ZM22.8333 22.8333H21V19.1667H22.8333V22.8333Z",
    fill: "#BE1D3D"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRefreshChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RefreshChart.250170fd2a9b49eb0ddf96d5f7728e4e.svg";